import {
  PeopleFilterFields,
  PersonEvaluationAggregateFilterFields,
} from 'src/app/people/models/peopleFilterFields';
import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataFilterValues,
  ODataSubFilter,
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator, OPERATORS } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class EvaluationAggregateFieldFilterModel implements ODataFilter {
  childFieldName = PeopleFilterFields.evaluationAggregates;
  filterGroup = FilterGroup.EvaluationQuestions;
  targetField = PersonEvaluationAggregateFilterFields.questionId;
  subFilter = new ODataSubFilter();
  constructor(
    public displayName: string,
    public targetFieldId: string,
    public valueType: SearchValueType,
    public values?: any[] | ODataFilterValues[]
  ) {}

  buildFilter(searchValue: any, filterOperator: FilterOperator) {
    if (this.valueType == SearchValueType.EvaluationAggregateMultiValue) {
      return this.buildEnumeratedTypeFilter(searchValue, filterOperator);
    } else if (this.valueType == SearchValueType.EvaluationAggregateString) {
      return this.buildStringTypeFilter(searchValue, filterOperator);
    } else if (this.valueType == SearchValueType.Number) {
      return this.buildStarRatingTypeFilter(searchValue, filterOperator);
    } else {
      throw new Error('Invalid Operation');
    }
  }
  buildEnumeratedTypeFilter(searchValue: ODataFilterValues[], filterOperator: FilterOperator) {
    let searchListValue: any;
    if (!searchValue) {
      searchListValue = '';
    } else {
      if (searchValue.find((x) => x.searchValue)) {
        searchListValue = searchValue.map((x) => x.searchValue);
      } else {
        searchListValue = searchValue.map((x) => x.name);
      }
    }
    if (filterOperator.displayOperator == FilterOperatorType.in) {
      return {
        [this.childFieldName]: {
          any: [
            ODataFilterBuilder.buildArrayFilter(
              PersonEvaluationAggregateFilterFields.questionItemId,
              searchListValue
            ),
            ODataFilterBuilder.buildNumberFilter(
              `to_double(${PersonEvaluationAggregateFilterFields.aggregateResponseValue})`,
              '0',
              FilterOperatorType.gt
            ),
          ],
        },
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.notIn) {
      return {
        and: {
          not: {
            [this.childFieldName]: {
              any: [
                ODataFilterBuilder.buildArrayFilter(
                  PersonEvaluationAggregateFilterFields.questionItemId,
                  searchListValue
                ),
                ODataFilterBuilder.buildNumberFilter(
                  `to_double(${PersonEvaluationAggregateFilterFields.aggregateResponseValue})`,
                  '0',
                  FilterOperatorType.gt
                ),
              ],
            },
          },
          [this.childFieldName]: {
            any: [ODataFilterBuilder.buildGuidFilter(this.targetField, this.targetFieldId)],
          },
        },
      };
    } else throw new Error('Invalid Operation');
  }

  private buildStringTypeFilter(searchValue: any, filterOperator: FilterOperator) {
    let _searchValue =
      filterOperator.displayOperator == FilterOperatorType.isEmpty ||
      filterOperator.displayOperator == FilterOperatorType.isNotEmpty
        ? null
        : searchValue;
    if (
      filterOperator.displayOperator == FilterOperatorType.contains ||
      filterOperator.displayOperator == FilterOperatorType.isNotEmpty
    ) {
      return {
        [this.childFieldName]: {
          any: [
            ODataFilterBuilder.buildGuidFilter(this.targetField, this.targetFieldId),
            ODataFilterBuilder.buildStringFilter(
              PersonEvaluationAggregateFilterFields.aggregateResponseValue,
              _searchValue,
              filterOperator.actualOperator
            ),
          ],
        },
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.notContains) {
      return {
        [this.childFieldName]: {
          any: [
            ODataFilterBuilder.buildGuidFilter(this.targetField, this.targetFieldId),
            {
              not: [
                ODataFilterBuilder.buildStringFilter(
                  PersonEvaluationAggregateFilterFields.aggregateResponseValue,
                  _searchValue,
                  FilterOperatorType.contains
                ),
              ],
            },
          ],
        },
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.isEmpty) {
      return {
        [this.childFieldName]: {
          any: [],
        },
        not: {
          [this.childFieldName]: {
            any: [ODataFilterBuilder.buildGuidFilter(this.targetField, this.targetFieldId)],
          },
        },
      };
    } else {
      throw new Error('Invalid Operation');
    }
  }
  private buildStarRatingTypeFilter(searchValue: any, filterOperator: FilterOperator) {
    let operatorTypes = OPERATORS[this.valueType];

    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    }

    let _searchValue =
      filterOperator.displayOperator == FilterOperatorType.isEmpty ||
      filterOperator.displayOperator == FilterOperatorType.isNotEmpty
        ? 0
        : searchValue;

    let filter = {
      [this.childFieldName]: {
        any: [
          ODataFilterBuilder.buildGuidFilter(this.targetField, this.targetFieldId),
          ODataFilterBuilder.buildNumberFilter(
            `to_double(${PersonEvaluationAggregateFilterFields.aggregateResponseValue})`,
            _searchValue,
            filterOperator.actualOperator
          ),
        ],
      },
    };
    return filter;
  }
}
